import { WorkByProductionActionsContext } from "@/features/workByProductionPlan/context/WorkByProductionProvider";
import { useContext } from "react";

export function useWorkByProductionActions() {
  const value = useContext(WorkByProductionActionsContext);
  if (value === undefined) {
    throw new Error("useCounterActions should be used within CounterProvider");
  }
  return value;
}
